import {Component, OnInit, Input} from '@angular/core';
import {BaseHttpService} from '../../../../services/base-http/base-http.service';

@Component({
  selector: 'app-offer-contact-form',
  templateUrl: './offer-contact-form.component.html',
  styleUrls: ['./offer-contact-form.component.scss']
})
export class OfferContactFormComponent implements OnInit {
  @Input() parent: any;
  @Input() selectedOfferId?: number;
  isCaptchaSuccess: boolean;
  isEmailValid: boolean;
  isRequestMessageValid: boolean;
  error: string;

  constructor(private httpService: BaseHttpService) {
  }

  ngOnInit() {
  }

  public clickOnSendButton(name: string, email: string, phone: string, question: string): void {
    if (!this.isEmailValid) {
      this.error = 'email';
      return;
    }
    if (!this.isCaptchaSuccess) {
      this.error = 'captcha';
      return;
    }
    const header = this.selectedOfferId ? 'Offer ID : ' + this.selectedOfferId : 'Logos Website inquiry ';
    window.alert('Request sent for ' + header);
    this.parent.isContactFormShown = false;
    this.httpService.postNewRequest(header, name, email, phone, question, () => {
        window.alert('Request sent !');
        this.parent.isContactFormShown = false;
      }
    );
  }

  isHeaderFixed(): boolean {
    return this.parent.constructor.name === 'DetailedOfferMenuComponent';
  }

  onEmailInput(email: string): void {
    this.isEmailValid = this.validateEmail(email);
  }

  onRequestInput(message: string): void {
    this.isRequestMessageValid = message.replace(' ', '').length > 5;
  }

  validateEmail(email: string): boolean {
    const re = /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  handleCorrectCaptcha(): void {
    this.isCaptchaSuccess = true;
    if (this.error === 'email') {
      this.error = '';
    }
  }

  private handleCaptchaExpired(): void {
    this.isCaptchaSuccess = false;
    if (this.error === '') {
      this.error = 'email';
    }
  }
}
